<template>
  <v-app id="inspire">
    <v-row
      align="center"
      justify="center"
    >
      <v-col
        cols="12"
        sm="8"
        md="4"
      >
        <amplify-authenticator v-bind:authConfig="authConfig">
          <amplify-sign-in slot="sign-in" hide-sign-up="true"></amplify-sign-in>
        </amplify-authenticator>
      </v-col>
    </v-row>
  </v-app>
</template>

<script>
export default {
  name: "CustomAuth",
  data() {
    return {
      authConfig: {
        signInConfig: {
          header: 'ログイン',
          isSignUpDisplayed : false,  // サインアップを出さない
          hideSignUp: true
        },
//        signUpConfig: {
//          hideDefaults: true,
//          signUpFields: [
//            { label: 'ユーザーID（メールアドレス）', key: 'username', required: true, type: 'email', displayOrder: 0 },
//            { label: 'パスワード', key: 'password', required: true, type: 'password', displayOrder: 1 },
////            { label: 'メールアドレス', key: 'email', required: true, type: 'email', displayOrder: 2 },
//            { label: 'お名前', key: 'name', required: true, displayOrder: 2 },
//            { label: '事業所コード', key: 'custom:OfficeID', required: true, displayOrder: 3 },
//          ],
//          hiddenDefaults: ["phone_number"]
//        }
      }
    };
  }
};
</script>
